module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "seller",
    staticClass: "seller"
  }, [_c('div', {
    staticClass: "seller-content"
  }, [_c('div', {
    staticClass: "overview"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.seller.name))]), _vm._v(" "), _c('div', {
    staticClass: "desc border-1px"
  }, [_c('star', {
    attrs: {
      "size": 36,
      "score": _vm.seller.score
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("(" + _vm._s(_vm.seller.ratingCount) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("月售" + _vm._s(_vm.seller.sellCount) + "单")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "remark"
  }, [_c('li', {
    staticClass: "block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("起送价")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "stress"
  }, [_vm._v(_vm._s(_vm.seller.minPrice))]), _vm._v("元\n          ")])]), _vm._v(" "), _c('li', {
    staticClass: "block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("商家配送")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "stress"
  }, [_vm._v(_vm._s(_vm.seller.deliveryPrice))]), _vm._v("元\n          ")])]), _vm._v(" "), _c('li', {
    staticClass: "block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("平均配送时间")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "stress"
  }, [_vm._v(_vm._s(_vm.seller.deliveryTime))]), _vm._v("分钟\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "favorite",
    on: {
      "click": function($event) {
        _vm.toggleFavorite($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon-favorite",
    class: {
      'active': _vm.favorite
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.favoriteText))])])]), _vm._v(" "), _c('split'), _vm._v(" "), _c('div', {
    staticClass: "bulletin"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("公告与活动")]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.seller.bulletin))])]), _vm._v(" "), (_vm.seller.supports) ? _c('ul', {
    staticClass: "support"
  }, _vm._l((_vm.seller.supports), function(item, index) {
    return _c('li', {
      staticClass: "support-item"
    }, [_c('span', {
      staticClass: "icon",
      class: _vm.classMap[_vm.seller.supports[index].type]
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(" " + _vm._s(_vm.seller.supports[index].description) + " ")])])
  })) : _vm._e()]), _vm._v(" "), _c('split'), _vm._v(" "), _c('div', {
    staticClass: "pics"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("商家实景")]), _vm._v(" "), _c('div', {
    ref: "picWrapper",
    staticClass: "picwrapper"
  }, [_c('ul', {
    ref: "picList",
    staticClass: "pic-list"
  }, _vm._l((_vm.seller.pics), function(pic) {
    return _c('li', {
      staticClass: "pic-item"
    }, [_c('img', {
      attrs: {
        "width": "120",
        "height": "90",
        "src": pic,
        "alt": ""
      }
    })])
  }))])]), _vm._v(" "), _c('split'), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "title border-1px"
  }, [_vm._v("商家信息")]), _vm._v(" "), _c('ul', _vm._l((_vm.seller.infos), function(info) {
    return _c('li', {
      staticClass: "info-item"
    }, [_vm._v(_vm._s(info))])
  }))]), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("已经到底啦")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b01305d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/seller/seller.vue
// module id = 49
// module chunks = 0